import { createExpirationDate } from "../utils";
export function enforceAccessTokenScheme(searchParams) {
  const {
    accessToken,
    expiresIn,
    ...rest
  } = searchParams;
  return { ...rest,
    token: accessToken,
    expiration: createExpirationDate(expiresIn)
  };
}